import { NpiProductRequestButton } from '@/features/product/CreatePrereservation/ui/NpiProductRequestButton/NpiProductRequestButton'

import { TProduct } from '@/shared/types/product-types'

interface CreatePrereservationProps {
	data: TProduct
	size?: 'S' | 'M' | 'L'
	fullWidth?: boolean
	buttonName?: string
}

export const CreatePrereservation = (props: CreatePrereservationProps) => {
	const { data, buttonName } = props

	return (
		<NpiProductRequestButton $modalContentData={data} id="gtm-preservation-inform-catalog">
			{buttonName ?? 'Сообщить о поступлении'}
		</NpiProductRequestButton>
	)
}
